import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import viVN from "antd/locale/vi_VN";
import zhTW from "antd/locale/zh_TW";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import localStorageKey from "./enumerations/localStorageKey";
import "./index.css";
import { startSentry } from "./plugins/apm";
import reportWebVitals from "./reportWebVitals";

// import "antd/dist/antd.variable.min.css";

const currentTheme = require(`./theme/${process.env.REACT_APP_PROD_NAME_DEV}/theme.json`);
const defaultTheme = require(`./theme/defaultTheme.json`);
const finalTheme = { ...defaultTheme, ...currentTheme };

startSentry();

// console.log("finalTheme", finalTheme);
ConfigProvider.config({
  theme: {
    token: finalTheme,
    // components: {
    //   Radio: {
    //     /* here is your component tokens */
    //   },
    // },
  },
});

//!! if add new lang, please update this Object for locale of antd components
const localeDict: any = {
  "zh-TW": zhTW,
  "en-US": enUS,
  "vi-VN": viVN,
  default: zhTW,
};

const lang =
  window.localStorage.getItem(localStorageKey.DEFAULT_LANG) ??
  process.env.REACT_APP_DEFAULT_LANG ??
  "zh-TW";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      //ms time until subsequent request will be triggered again
      staleTime: 3000,
      //when request failed, by default will retry 3x with exponential backoff delay before returning error
      //turn off this option on dev mode to make quicker dev experience
      retry: false,
      //option to refetch data when windows on focus to keep showing latest data to user
      //also turn this off on dev env for simplicity
      refetchOnWindowFocus: false,
    },
  },
});

root.render(
  <React.StrictMode>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          autoInsertSpaceInButton={false}
          theme={{ token: finalTheme }}
          locale={localeDict[lang] ?? localeDict.default}
        >
          <App />
        </ConfigProvider>
      </QueryClientProvider>
    </React.StrictMode>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
